import RootLayout from 'layouts/RootLayout';
import React, { ReactElement } from 'react';
import Breadcrumbs from 'components/Breadcrumbs';

export default function MembersRegulationsPage() {
  return (
    <section className="members-regulations">
      <div className="container">
        <Breadcrumbs mTop={64} mode="dark" links={[{ title: 'Membership Regulations', href: '' }]} />

        <h1 className="heading__section">Membership Regulations</h1>
        <h2>To join the Digital Freight Alliance, you need to fulfill several requirements:</h2>
      </div>

      <main className="main-wrap">
        <div className="regulations-box">
          <div className="box-text">
            <p>
              * You need to submit an application and fill out a KYC form. Upon completion, we will review your
              candidacy for membership, and DP World's respective board will decide whether the applicant will be
              accepted or not.
            </p>
            <p>
              * You can apply for no more than 3 locations in one country unless otherwise decided in particular cases
            </p>
          </div>
        </div>
      </main>
    </section>
  );
}

export const getStaticProps = async () => {
  return {
    props: {
      title: 'Membership Regulations at DF Alliance | DF Alliance',
      description:
        'Review DF Alliance\'s membership regulations online to ensure a smooth and seamless experience while joining our global freight forwarding network.',
      keywords: 'freight member regulations, freight alliance regulation',
      path: '/company/membership-regulations',
    },
  };
};

MembersRegulationsPage.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
